import {Component, Fragment} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {funcNavigate} from "../../../../settings/utils/functions";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {NavLink} from "react-router-dom";
import {header} from "../../components/header";
import {footer} from "../../components/footer";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import PaginationFilter from "../../components/PaginationFilter";
import {notFound} from "../../components/notFound";

class Search extends Component {
    static contextType = simplyContext

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const pageValue = searchParams.get('page');
        const searchValue = searchParams.get('search');
        this.context.fSearch({
            'pageNumber': pageValue, 'search': searchValue
        })
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context)
        if (this.props.location.key !== prevProps.location.key) {
            const searchParams = new URLSearchParams(this.props.location.search);
            const pageValue = searchParams.get('page');
            const searchValue = searchParams.get('search');
            this.context.fSearch({
                'pageNumber': pageValue, 'search': searchValue
            })
        }
    }


    render() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const searchValue = searchParams.get('search');
        return (
            <HelmetProvider>
                <Helmet>
                    <title>جستجو</title>
                </Helmet>

                {this.context.state.sSearch !== null ? (
                    <div className='container-fluid cFlex1'>

                        {header(this.context)}


                        <div className='row py-2 cBg7 justify-content-center cPx1 cBrudcRum'>
                            <div className='cContainer col-12'>
                                <div className='row justify-content-center'>
                                    <div className='col-12 lh-lg'>
                                        <NavLink to={urlDynamic.path.homeFa}
                                                 className='text-white cFontSize13     cTransition'>صفحه
                                            اصلی</NavLink>
                                        <span className='mx-1 cFontSize13 text-white'>/</span>
                                        <h1 className='cColor2 d-inline-block cFontSize13'>جستجو</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.context.state.sSearch.notFound === true ? (
                            notFound()
                        ) : (
                            <div className='row pt-5 position-relative   cBg12 cBoxShadow1  justify-content-center cPx1 cFlex2'>
                                <div className='cContainer col-12'>
                                    <div className='row justify-content-center'>
                                        <div className='col-12 cZindex2'>
                                            {searchValue !== null ? (
                                                <div className='p-5 cBg10 rounded rounded-3'>
                                                    <h2 className='cFontSize14_768 cFontSize16 lh-lg cColor2 mb-3'>نتایج
                                                        جستجو برای
                                                        عبارت "
                                                        <strong>
                                                            {' ' + searchValue + ' '}
                                                        </strong>
                                                        "
                                                    </h2>

                                                    {this.context.state.sSearch.search.length > 0 ? (
                                                        <Fragment>
                                                            <h3 className='cFontSize14 mb-3 lh-lg'>{this.context.state.sSearch.pageCount} نتیجه
                                                                یافت شد </h3>
                                                            {this.context.state.sSearch.search.map((p, index) => (
                                                                <div key={index}
                                                                     className='cJustify cBorder1 position-relative border px-3 cBg12 cBoxShadow1 mb-3 py-3'>
                                                                    {p.searchTitle ? (
                                                                        <div className='d-md-flex align-items-center'>
                                                                            <p className='mb-2 lh-lg flex-grow-1 me-4 cColor2 fw-bold'>
                                                                                {p.searchTitle}
                                                                            </p>
                                                                            <div className='text-center text-md-end mt-2 mt-md-0'>
                                                                                <NavLink target={"_blank"} to={p.urlFile}
                                                                                         key={index}
                                                                                         className="">
                                                                                    <img src={p.urlImage} width="150"
                                                                                         height='100'
                                                                                         className="img-fluid img-thumbnail"
                                                                                         alt="تصویر"/>
                                                                                </NavLink>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <Fragment>
                                                                            <p className='mb-2 lh-lg cColor2 fw-bold'>
                                                                                {p.title !== null ? p.title : p.url.replace(/-/g, ' ')}
                                                                            </p>
                                                                            <div className='text-end'>
                                                                                <NavLink to={'/' + p.url}
                                                                                         target='_blank'
                                                                                         className='text-dark card-title cFontSize13 fw-bold    cTransition d-inline-block'>مشاهده
                                                                                </NavLink>
                                                                                <span
                                                                                    className='badge bg-warning ms-2 text-dark'>{p.dasteBandi}</span>
                                                                            </div>
                                                                        </Fragment>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </Fragment>
                                                    ) : (
                                                        <h3 className='cFontSize14 lh-lg'>نتیجه ای یافت نشد</h3>
                                                    )}


                                                </div>
                                            ) : null}
                                        </div>
                                        <div className='col-12 mb-5 mt-5'>
                                            <PaginationFilter func={this.context.fDropDown}
                                                              state={this.context.state.sSearch}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                        {footer()}


                    </div>
                ) : null}

            </HelmetProvider>
        )
    }
}

export default withRouter(Search)